import { parameterInstance } from '../utils/axiosConfig';

const GeneralSettingsService = {
    // Méthode pour créer un nouveau paramètre
    createParameter: async (parameter) => {
        try {
            const response = await parameterInstance.post('/create', parameter, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in createParameter:', error.message || error);
            throw error;
        }
    },

    // Méthode pour mettre à jour un paramètre existant
    updateParameter: async (parameter) => {
        try {
            const response = await parameterInstance.put('/update', parameter, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in updateParameter:', error.message || error);
            throw error;
        }
    },

    // Méthode pour supprimer un paramètre par ID
    deleteParameter: async (id) => {
        try {
            const response = await parameterInstance.delete(`/delete/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in deleteParameter:', error.message || error);
            throw error;
        }
    },

    // Méthode pour récupérer tous les paramètres
    getAllParameters: async () => {
        try {
            const response = await parameterInstance.get('/findAll');
            return response.data;
        } catch (error) {
            console.error('Error in getAllParameters:', error.message || error);
            throw error;
        }
    },

    // Méthode pour récupérer un paramètre par ID
    getParameterById: async (id) => {
        try {
            const response = await parameterInstance.get(`/find/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getParameterById:', error.message || error);
            throw error;
        }
    }
};

export default GeneralSettingsService;